import axios from 'axios'
import { ApiResponse, OkxSwapParams } from './okx.types'

const api_config = {
  api_key: 'd1807fde-aa09-4c65-972d-e2fb19a8d3d5',
  secret_key: '3F558CC8EF8EDE372B67E34354B0C34A',
  passphrase: 'Holdstation@123',
  project: '29742b21435f53b92444adf54857fe84', // Applies only to onchainOS APIs
}
const BASE_URL = 'https://www.okx.com'
export const SWAP_FEE_PERCENT = '0.2'
export const INTEGRATOR_ADDRESS = '0x8D61D7fE817efc69A2169f0d5f39b41ed5c89409'

function paramsSerializer(params: Record<string, string>): string {
  return Object.entries(params)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
    .join('&')
}

function preHash(timestamp: string, method: string, requestPath: string, params: any): string {
  let body = ''
  if (method === 'GET' && params) {
    const queryString = paramsSerializer(params)
    requestPath += `?${queryString}`
  } else if (method === 'POST' && params) {
    body = JSON.stringify(params)
  }
  return `${timestamp}${method}${requestPath}${body}`
}

// Instead of:
// import { createHmac } from 'crypto'

// Use the SubtleCrypto API for HMAC operations
async function sign(message: string, secretKey: string): Promise<string> {
  const encoder = new TextEncoder()
  const keyData = encoder.encode(secretKey)
  const messageData = encoder.encode(message)

  const cryptoKey = await window.crypto.subtle.importKey('raw', keyData, { name: 'HMAC', hash: 'SHA-256' }, false, [
    'sign',
  ])

  const signature = await window.crypto.subtle.sign('HMAC', cryptoKey, messageData)

  // Convert to base64
  return btoa(String.fromCharCode(...new Uint8Array(signature)))
}

async function createSignature(method: string, requestPath: string, params: any) {
  const timestamp = new Date().toISOString()
  const message = preHash(timestamp, method, requestPath, params)
  const signature = await sign(message, api_config.secret_key)
  return { signature, timestamp }
}

export async function swapOkxRequest(requestPath: string, params: OkxSwapParams) {
  const { signature, timestamp } = await createSignature('GET', requestPath, params)

  const headers = {
    'OK-ACCESS-KEY': api_config.api_key,
    'OK-ACCESS-SIGN': signature,
    'OK-ACCESS-TIMESTAMP': timestamp,
    'OK-ACCESS-PASSPHRASE': api_config.passphrase,
    'OK-ACCESS-PROJECT': api_config.project, // Applies only to WaaS APIs
    'Content-Type': 'application/json',
  }

  const axiosClient = axios.create({
    baseURL: BASE_URL,
    headers,
  })

  const response = await axiosClient.get(requestPath, { params })
  return response.data as ApiResponse
}
